// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";
import { Button, Tooltip } from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { LockClosedRegular, PeopleTeamRegular } from "@fluentui/react-icons";
import { IUserProduct } from "../../Models/IUserProduct";
import FreigabeDialog from "../FreigabeDialog/FreigabeDialog";

// Internal Imports

// Props
interface IProductCommandbarProps {
  userProduct: IUserProduct;
  onRefresh(): void;
}

// Function
function UserProductCommandbar(props: IProductCommandbarProps) {
  const [freigabeDialogOpen, setFreigabeDialogOpen] = useState<boolean>(false);

  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 800;

  return (
    <div className="lueb-InnerContentBlockPadding2px">
      {freigabeDialogOpen && (
        <FreigabeDialog
          onDismiss={() => {
            setFreigabeDialogOpen(false);
          }}
          onSave={() => {
            setFreigabeDialogOpen(false);

            props.onRefresh();
          }}
          isDialogOpen={freigabeDialogOpen}
          objectGuid={props.userProduct.userProduktGuid}
          objectType="UserProduct"
          referenceGuid=""
        />
      )}

      <StackShim
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: isMobile ? 15 : 0 }}
      >
        {props.userProduct.userProduktGuid && (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("shareObject")!}
          >
            <Button
              appearance="subtle"
              disabled={!props.userProduct.canCreateFreigabe}
              icon={
                props.userProduct.hasFreigaben ? (
                  <PeopleTeamRegular color="#ff6600" />
                ) : (
                  <LockClosedRegular color="#ff6600" />
                )
              }
              onClick={() => {
                setFreigabeDialogOpen(true);
              }}
            >
              {props.userProduct.hasFreigaben
                ? i18n.t<string>("editShareObject")
                : i18n.t<string>("shareObject")}
            </Button>
          </Tooltip>
        )}
      </StackShim>
    </div>
  );
}

// Export Function
export default UserProductCommandbar;
